import { BaseFormState } from '~/types/BaseFormState';
import styles from './InlineGroup.module.css';
import { DeepKeyof } from '~/types/DeepKeyof';
import { FormState } from 'react-hook-form';
import { PropsWithChildren } from 'react';
import classNames from 'classnames';

type Props<TFormState extends BaseFormState> = PropsWithChildren & {
  formState?: FormState<TFormState>;
  htmlFor: DeepKeyof<TFormState>;
  neutral?: boolean;
  label: string;
};

export function InlineGroup<TFormState extends BaseFormState>(props: Props<TFormState>) {
  const { formState, children, htmlFor, label, neutral = false } = props;

  return (
    <div
      className={classNames(styles.inlineGroup, {
        [styles.neutral]: neutral,
      })}
    >
      <label
        className={classNames(styles.label, {
          [styles.error]: !!formState?.errors[htmlFor]?.message,
        })}
      >
        {children}
        {label}
      </label>
      {formState?.errors[htmlFor]?.message && (
        <small className={styles.error}>{formState?.errors[htmlFor].message as string}</small>
      )}
    </div>
  );
}
